import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import common from './locales/common/translation.json';
import en from './locales/en/translation.json';
import ee from './locales/ee/translation.json';

const selectedLanguage = localStorage.getItem('lang');

i18n.use(initReactI18next).init({
  lng: selectedLanguage || 'en',
  debug: true,
  resources: {
    en: {
      translations: en,
      common
    },
    ee: {
      translations: ee,
      common
    },
  },
  ns: ['common', 'translations'],
  defaultNS: 'translations'
});

export default i18n;
